import {
  ArrowRight,
  LayoutGrid,
  Thermometer,
  Users,
  Radio,
} from "lucide-react";

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden bg-paper">
      <div className="mx-auto grid max-w-content items-center gap-14 px-5 pb-16 pt-14 sm:px-8 sm:pb-24 sm:pt-20 lg:grid-cols-2 lg:gap-10 lg:pb-28 lg:pt-24">
        <div>
          <span className="inline-flex items-center gap-2 rounded-full bg-accent-light px-3.5 py-1.5 text-[13px] font-medium text-accent-dark">
            <LayoutGrid size={15} strokeWidth={2.25} />
            L'appli tout-en-un des commerces alimentaires
          </span>

          <h1 className="mt-6 text-[2.35rem] font-semibold leading-[1.12] tracking-tight text-ink sm:text-5xl lg:text-[3.25rem]">
            Toute la gestion de votre commerce, dans une seule application.
          </h1>

          <p className="mt-6 max-w-xl text-lg leading-relaxed text-ink-soft">
            Hygio réunit dans un seul outil ce qui vous prenait plusieurs
            applications différentes : planning et pointage de vos équipes en
            temps réel, conformité HACCP, stocks et comptage de caisse.
            Simple, connecté, pensé pour le terrain.
          </p>

          <div className="mt-9 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#contact"
              className="inline-flex items-center justify-center gap-2 rounded-full bg-accent px-7 py-3.5 text-[15px] font-medium text-white shadow-soft transition-colors hover:bg-accent-dark"
            >
              Demander une démo
              <ArrowRight size={17} strokeWidth={2.25} />
            </a>
            <a
              href="#fonctionnalites"
              className="inline-flex items-center justify-center rounded-full border border-ink/10 bg-white px-7 py-3.5 text-[15px] font-medium text-ink transition-colors hover:border-ink/20 hover:bg-mist"
            >
              Découvrir les fonctionnalités
            </a>
          </div>

          <p className="mt-6 text-sm text-ink-soft">
            Boulangeries, restaurants, boutiques alimentaires — sur mobile,
            tablette ou ordinateur.
          </p>
        </div>

        <div className="relative mx-auto w-full max-w-md lg:max-w-none">
          <div className="absolute -inset-x-6 -inset-y-6 -z-10 rounded-[2rem] bg-accent-light/60 blur-2xl sm:-inset-x-10 sm:-inset-y-10" />

          <div className="rounded-2xl border border-ink/[0.06] bg-white p-5 shadow-lift sm:p-6">
            <div className="flex items-center justify-between border-b border-ink/[0.06] pb-4">
              <div className="flex items-center gap-2">
                <span className="h-2.5 w-2.5 rounded-full bg-accent" />
                <span className="text-sm font-medium text-ink">
                  Tableau de bord — aujourd'hui
                </span>
              </div>
              <span className="rounded-full bg-mist px-2.5 py-1 text-xs font-medium text-ink-soft">
                Boulangerie du Marché
              </span>
            </div>

            <div className="mt-5 grid grid-cols-2 gap-3">
              <div className="rounded-xl bg-mist p-4">
                <div className="flex items-center gap-2 text-ink-soft">
                  <Users size={16} />
                  <span className="text-xs font-medium">Équipe présente</span>
                </div>
                <p className="mt-2 text-2xl font-semibold text-ink">4/5</p>
                <p className="mt-0.5 text-xs font-medium text-emerald-600">
                  En poste
                </p>
              </div>

              <div className="rounded-xl bg-mist p-4">
                <div className="flex items-center gap-2 text-ink-soft">
                  <Thermometer size={16} />
                  <span className="text-xs font-medium">Chambre froide</span>
                </div>
                <p className="mt-2 text-2xl font-semibold text-ink">3,2°C</p>
                <p className="mt-0.5 text-xs font-medium text-emerald-600">
                  Conforme
                </p>
              </div>
            </div>

            <div className="mt-3 rounded-xl bg-mist p-4">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2 text-ink-soft">
                  <Radio size={16} />
                  <span className="text-xs font-medium">
                    Badgeage en direct
                  </span>
                </div>
                <span className="text-xs font-medium text-ink-soft">
                  08:58
                </span>
              </div>
              <p className="mt-2 text-sm font-medium text-ink">
                Camille a pointé son arrivée — suivi automatique
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
